import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Common } from '@trimblemaps/trimblemaps-js';
import { SubscriptionLevel } from 'src/app/auth/models/user';
import { BillingLevel, BILLINGLEVELOPTIONS } from 'src/app/utils/billingLevel';
import { featuresData } from 'src/app/utils/features';
import { CurrencyState } from 'src/app/_models/state/optionUIState';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-feature',
  templateUrl: './feature.component.html',
  styleUrls: ['./feature.component.scss'],
})
export class FeatureComponent {
  @Output() featureLevel = new EventEmitter<any>();
  @Input() displayCurrency: CurrencyState;
  trialPeriod = environment.trialPeriod;
  featureData = featuresData;
  billingLevel = BillingLevel;
  featureCost = BILLINGLEVELOPTIONS.find((F) => F.name === BillingLevel.PREMIUM)
    ?.cost;

  navigateToForm(item: string) {
    this.featureLevel.emit(item);
  }
}
